import { useContext, useRef, useState } from 'react';
import { useMutation } from 'react-query';
import {
	Link,
	useNavigate,
	useSearchParams
} from 'react-router-dom';
import { authActions } from '../../api/authAPI';
import AuthContext from '../../store/auth-context';
import Button from '../ui/Button';
import { Icon } from '@mui/material';
import LogoAquamarine from '../../assets/logo_aquamarine.svg?react';
import './AuthForm.scss';

function AuthForm() {
	const authCtx = useContext(AuthContext);
	const authMutation = useMutation((authData) => {
		return authActions(authData);
	});

	const navigate = useNavigate();

	const emailRef = useRef();
	const passRef = useRef();

	const [disabledEmail, setDisabledEmail] = useState(true);
	const [disabledPasswd, setDisabledPasswd] =
		useState(true);
	const [sendResetMessage, setSendResetMessage] = useState(
		'Please enter your email and we will reset your password.'
	);
	const [initialMessage, setInitialMessage] = useState('');

	const [searchParams] = useSearchParams();
	const isLogin = searchParams.get('mode') !== 'forgotPass';
	const authMode = isLogin ? 'login' : 'forgotPass';

	const submitHandler = (event) => {
		event.preventDefault();
		const emailInput = emailRef.current.value.toLowerCase();
		let passInput = null;

		if (authMode === 'login') {
			passInput = passRef.current.value;
			authMutation.mutate(
				{
					email: emailInput,
					password: passInput,
					mode: authMode
				},
				{
					onSuccess: (data) => {
						const userData = data.data.user;
						const token = data.data.token;
						authCtx.login(token, userData);

						if (authMode === 'login') {
							navigate('/dashboard');
						}

						if (userData.mustChangePassword) {
							navigate(`/reset-password/${userData.email}`);
						}
					},
					onError: () => {
						navigate('/login');
					}
				}
			);
		}

		if (authMode === 'forgotPass') {
			authMutation.mutate(
				{
					email: emailInput,
					password: passInput,
					mode: authMode
				},
				{
					onSuccess: (data) => {
						setInitialMessage(
							'A new password has been sent to your email'
						);
						navigate('/login');
					},
					onError: () => {
						console.log('ops');
						navigate('/login');
					}
				}
			);
		}
	};

	//TODO ADD CORRECT VALIDATIONS FOR EMAILS

	const changeEmailHandler = () => {
		const emailVal = emailRef.current.value;

		if (emailVal.length > 0) {
			setDisabledEmail(false);
		} else {
			setDisabledEmail(true);
		}
	};

	const changePasswHandler = () => {
		const passVal = passRef.current.value;
		if (passVal.length > 0) {
			setDisabledPasswd(false);
		} else {
			setDisabledPasswd(true);
		}
	};

	let disabledLogin = 'true';

	if (authMode === 'login') {
		if (!disabledEmail && !disabledPasswd) {
			disabledLogin = false;
		}
	}

	if (authMode === 'forgotPass') {
		if (!disabledEmail) {
			disabledLogin = false;
		}
	}
	const formLabels = (
		<>
			<strong className='auth-form-initial-labels'>
				{' '}
				<p className='initial-message'>{initialMessage}</p>
				<p>
					{isLogin
						? 'Log In Your Account'
						: 'Forgot Password?'}
				</p>
				<p className='second-message'>
					{isLogin ? '' : sendResetMessage}
				</p>
			</strong>

			{authMutation.isLoading ? 'authenticating...' : null}
			{authMutation.isError ? (
				<div className='login-error-container'>
					An error Ocurred:
					{` ${authMutation.error.response.data.msg}`}
				</div>
			) : null}
		</>
	);

	return (
		<div className='auth-container'>
			<div className='auth-section brand-wrapper'>
				<div className='brand-container'>
					<img
						className='login-naur-logo'
						src='/login_logo.svg'
						alt='main-logo'
					/>
					<img
						className='login-doctor-image'
						src='/doctor-img-login.svg'
						alt='doctor-login'
					/>
				</div>
			</div>
			<div className='auth-section form-wrapper'>
				<div className='form-container'>
					<form
						onSubmit={submitHandler}
						className='auth-form'
					>
						<div className='avatar-wrapper'>
							<LogoAquamarine />
						</div>
						{formLabels}
						<div className='control-container auth-input-form'>
							<label
								htmlFor='email'
								className='auth-form-input-label'
							>
								Username
							</label>
							<input
								className='form-control'
								id='email'
								type='email'
								name='email'
								placeholder='example@gmail.com'
								required
								ref={emailRef}
								onChange={changeEmailHandler}
							/>
						</div>
						{isLogin ? (
							<div className='control-container auth-input-form'>
								<label
									htmlFor='image'
									className='auth-form-input-label'
								>
									Password
								</label>
								<input
									className='form-control'
									id='password'
									type='password'
									name='password'
									ref={passRef}
									required
									onChange={changePasswHandler}
								/>
							</div>
						) : (
							<></>
						)}

						<div className='form-cta-container'>
							<div className='form-cta-container-actions'>
								<Button
									disabled={disabledLogin}
									type='submit'
									className='primary-button auth-form-control'
								>
									{isLogin ? 'Log In' : 'Reset Password'}
								</Button>
							</div>
							<div className='form-link-labels'>
								{isLogin ? '' : <Icon>chevron_left</Icon>}
								<Link
									to={`?mode=${
										isLogin ? 'forgotPass' : 'login'
									}`}
									className='auth-form-control auth-footer-link'
								>
									{isLogin
										? 'Forgot Password?'
										: 'Go back to Log In'}
								</Link>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
}

export default AuthForm;
